// extracted by mini-css-extract-plugin
export var formContainer = "_dw-0";
export var message = "_dw-1";